import { render, staticRenderFns } from "./ConfirmWarningProp2.vue?vue&type=template&id=984ba3a4&"
import script from "./ConfirmWarningProp2.vue?vue&type=script&lang=js&"
export * from "./ConfirmWarningProp2.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmWarningProp2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports